import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap"; // Spinner optional
import Widget from "./Widgets";
import Section from "./Section";
import { Transactions } from "../../Components/custom/TransactionsTable";
import { SalesByRegions } from "../../Components/custom/SalesByRegions";
import UsersByDevice from "../DashboardAnalytics/UsersByDevice";
import Revenue from "./Revenue";

const DashboardEcommerce = () => {
  const [loader, setLoader] = useState(false);

  const getDefaultDates = () => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);
    return [lastMonth, today];
  };

  const [dateRange, setDateRange] = useState(getDefaultDates());
  const [rightColumn, setRightColumn] = useState(true);

  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  // 🔁 When dateRange changes, show loader for 1s
  useEffect(() => {
    setLoader(true);
    const timer = setTimeout(() => {
      setLoader(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [dateRange]);

  useEffect(() => {
    setDateRange(getDefaultDates());
  }, []);

  document.title = "Dashboard | Bozor";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Section
                  rightClickBtn={toggleRightColumn}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                />

                {loader && (
                  <div className="text-center my-5">
                    <Spinner color="primary" />
                  </div>
                )}

                <div style={loader ? { opacity: 0 } : { opacity: 1 }}>
                  <Row>
                    <Widget dateRange={dateRange} />
                  </Row>
                  <Revenue dateRange={dateRange} />
                  <UsersByDevice dateRange={dateRange} />
                  <SalesByRegions dateRange={dateRange} />
                  <Transactions hideStats={false} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
